import { Grid2, Typography } from "@mui/material";
import { CheckIcon, GKButton, PlusIcon, Show } from "components";
import GKModal from "components/GKModal";
import { RevenueManagerDetails } from "interfaces/Revenue";
import { useState } from "react";
import { feePlanApi } from "store/features/Revenue/FeePlan";
import { useAppDispatch } from "store/store";
import AdvanceFeeHistory from "./AdvanceFeeHistory";
import ConfirmationModal from "./ConfirmationModal";
import FeeDepositHistory from "./FeeDepositHistory";
import FeePlanHistory from "./FeePlanHistory";
import FeePlansTab from "./FeePlansTab";
import HighWaterMarkFormModal from "./HighWaterMarkFormModal";
import HighWaterMarkHistory from "./HighWaterMarkHistory";
import RevenueSharingForm from "./RevenueSharingForm";

interface Props {
  open: {
    open: boolean;
    type: string;
    modalTitle: string;
    width?: string;
    subTitle?: string;
  };
  setOpen: (open: {
    open: boolean;
    type: string;
    modalTitle: string;
    width?: string;
    subTitle?: string;
  }) => void;
  feePlanDetails: RevenueManagerDetails;
  portfolioId: string;
}

const RevenueActionModal = (props: Props) => {
  const { open, setOpen, feePlanDetails, portfolioId } = props;

  const dispatch = useAppDispatch();

  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [feePlanConfirmationModal, setFeePlanConfirmationModal] = useState({
    openModal: false,
    type: "",
    modalTitle: "",
  });
  const [highWatermarkData, setHighWatermarkData] = useState({});
  const [openSubModal, setOpenSubModal] = useState(false);

  const handleReturnComponent = (type: string) => {
    switch (type) {
      case "FEE_PLAN_CHANGE":
        return (
          <FeePlansTab
            feePlanDetails={feePlanDetails}
            rowSelectionModel={rowSelectionModel}
            setRowSelectionModel={setRowSelectionModel}
          />
        );
      case "FEE_PLAN_HISTORY":
        return <FeePlanHistory portfolioId={portfolioId} />;
      case "HIGH_WATERMARK":
        return (
          <HighWaterMarkHistory
            setOpenSubModal={setOpenSubModal}
            setHighWatermarkData={setHighWatermarkData}
          />
        );
      case "ADVANCE_FEE_HISTORY":
        return <AdvanceFeeHistory />;
      case "FEE_DEPOSIT_HISTORY":
        return <FeeDepositHistory />;
      case "REVENUE_SHARING":
        return (
          <RevenueSharingForm
            feePlanDetails={feePlanDetails}
            portfolioId={portfolioId}
            setOpen={setOpen}
          />
        );

      default:
        return <></>;
    }
  };

  return (
    <>
      <GKModal
        modalTitle={open?.modalTitle}
        open={open?.open}
        setOpen={() => {
          setOpen({ open: false, type: "", modalTitle: "" });
          open?.type === "HIGH_WATERMARK" &&
            dispatch(feePlanApi.util.invalidateTags(["RevenueByPortfolio"]));
        }}
        width={open?.width || "60%"}
        maxHeight="calc(100vh - 400px)"
        subTitle={
          open.type === "REVENUE_SHARING" && (
            <Typography
              fontSize={14}
              fontWeight={500}
              color="var(--neutral-500)"
            >
              {open?.subTitle}
            </Typography>
          )
        }
        titleComponent={
          open.type === "HIGH_WATERMARK" && (
            <GKButton
              startIcon={<PlusIcon />}
              onClick={() => {
                setHighWatermarkData({});
                setOpenSubModal(true);
              }}
            >
              Add High Watermark
            </GKButton>
          )
        }
        footer={
          <Grid2 container>
            {open?.type === "FEE_PLAN_CHANGE" && (
              <GKButton
                variant="contained"
                startIcon={<CheckIcon />}
                onClick={() => {
                  setFeePlanConfirmationModal({
                    openModal: true,
                    type: "FEE_PLAN_CHANGE",
                    modalTitle: "Confirm Fee Plan Change",
                  });
                }}
              >
                Change Fee Plan
              </GKButton>
            )}
          </Grid2>
        }
      >
        <Grid2 container>{handleReturnComponent(open.type)}</Grid2>
      </GKModal>

      <Show.When isTrue={feePlanConfirmationModal?.openModal}>
        <ConfirmationModal
          open={feePlanConfirmationModal}
          setOpen={setFeePlanConfirmationModal}
          portfolioId={portfolioId}
          rowSelectionModel={rowSelectionModel}
          feePlanDetails={feePlanDetails}
          feePlanModal={setOpen}
        />
      </Show.When>

      <Show.When isTrue={openSubModal}>
        <HighWaterMarkFormModal
          open={openSubModal}
          setOpen={setOpenSubModal}
          portfolioId={portfolioId}
          highWatermarkData={highWatermarkData}
        />
      </Show.When>
    </>
  );
};

export default RevenueActionModal;
